import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';
import { AuthGuardService } from 'src/app/shared/services/auth.service';
import { DevolutivaComponent } from './devolutiva.component';

const routes: Routes = [
    {
        path: ConstantsRotasDoSistema.DEVOLUTIVA + '/:id',
        component: DevolutivaComponent,
        canActivate: [AuthGuardService]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DevolutivaRoutingModule { }
